import * as zoid from "@krakenjs/zoid/dist/zoid.frameworks.js";

export const ProductModelEditor = zoid.create({
  tag: "product-model-editor",
  url: `${SERVER_URL}/product-model-editor`,
  dimensions: {
    width: "100%",
    height: "100%",
  },
});
